<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" style="display:none">
				<el-form-item>
					<el-input v-model="filters.q" placeholder="搜索"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getList">查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="listdata" highlight-current-row v-loading="loading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="index" width="60">
			</el-table-column>
			<el-table-column prop="Title" label="名称" width="120">
			</el-table-column>
			<el-table-column label="金额" align="center" width="100">
				<template slot-scope="{row}">
					<span style="color:#f60;">{{ row.Amounts }}</span>
				</template>
			</el-table-column>
			<el-table-column label="余额" align="center" width="100">
				<template slot-scope="{row}">
					<span style="color:#f60;font-weight:bold">{{ row.Balances }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="Timestr" label="时间" width="180">
			</el-table-column>
			<el-table-column label="描述">
        <template slot-scope="{row}">
          <span v-html="row.Desc"></span>
        </template>
			</el-table-column>
			<el-table-column label="状态" width="80">
				<template slot-scope="{row}">
					<span v-if="row.Signed" style="color:green">正常</span>
					<span v-else style="color:red">账号有误</span>
				</template>
			</el-table-column>
			<!-- <el-table-column label="操作" width="150">
				<template scope="{row}">
					<el-button-group>
						<el-button size="small" type="warning" @click="$refs.editor.show(row)">编辑</el-button>
						<el-button size="small" type="danger" @click="handleDel(row)">删除</el-button>
					</el-button-group>
				</template>
			</el-table-column> -->
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
			<el-pagination layout="prev, pager, next" :current-page.sync="filters.page" :total="total" :page-size="limit" @current-change="getList" style="float:right;">
			</el-pagination>
		</el-col>
	</section>
</template>

<script>
	export default {
		data() {
			return {
				filters:{
					page: 1,
					s:'',
					q:''
				},
				loading: false,
				total:0,
				limit:0,
				listdata: [],
				sels: [],//列表选中列
			}
		},
		mounted() {
			this.getList();
		},
		methods: {
			//获取列表
			getList() {
				this.loading = true;
				//NProgress.start();
				this.$post('/user/bills',this.filters).then((res) => {
              		console.log(res);
					this.loading = false;
					this.listdata = res.data.Data;
					this.total = res.data.Total;
					this.limit = res.data.Size;
					this.filters.page=res.data.Page;
					//NProgress.done();
				}).catch(err=>{
					this.$message({
						message: err.response.data||'服务器错误',
						type: 'error'
					});
				});
			},selsChange(sels) {
				this.sels = sels;
			},handleAdd(){

			},handleEdit(){

			},handleDel(){
				this.$confirm('确定要删除吗?', '提示', {
					type: 'warning'
				}).then(()=>{
				});
			},batchRemove(){

			}
		}
	}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// BillList.vue?63203464